interface IOrganizationSubscriptionAPI {
  organizationsubscription_id: number;
  organizationsubscription_type: string;
}

export default class OrganizationSubscription {
  id: number;
  organizationSubscriptionType: string;

  constructor(id: number, organizationSubscriptionType: string) {
    this.id = id;
    this.organizationSubscriptionType = organizationSubscriptionType;
  }

  static fromApi(apiObject) {
    return new OrganizationSubscription(apiObject.organizationsubscription_id, apiObject.organizationsubscription_type);
  }

  toApi() {
    return <IOrganizationSubscriptionAPI>{
      organizationsubscription_id: this.id,
      organizationsubscription_type: this.organizationSubscriptionType,
    };
  }
}
